import { render, staticRenderFns } from "./PdpRpaModalSearch.vue?vue&type=template&id=b0d9670c&"
import script from "./PdpRpaModalSearch.vue?vue&type=script&lang=js&"
export * from "./PdpRpaModalSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports